import testIds from "constants/testIds";

import ReviewComment from "./sections/ReviewComment";
import ReviewOrganisation from "./sections/ReviewOrganisation";
import ReviewPackingList from "./sections/ReviewPackingList";
import ReviewAttachments from "./sections/ReviewAttachments";
import ReviewProviders from "./sections/ReviewProviders";
import ReviewSchedule from "./sections/ReviewSchedule";
import ReviewService from "./sections/ReviewService";
import "./ReviewPage.scss";

type ReviewPageProps = {
  showProviderSummary: boolean;
};

export default function ReviewPage({ showProviderSummary }: ReviewPageProps) {
  return (
    <div className="rfv2-review" data-testid={testIds.REQUEST_FORM_REVIEW_PAGE}>
      <ReviewOrganisation />
      <ReviewService />
      <ReviewSchedule />
      <ReviewPackingList />
      {showProviderSummary ? <ReviewProviders /> : <ReviewAttachments />}
      <ReviewComment />
    </div>
  );
}
